module.exports = __webpack_public_path__ + "img/1.568ac1c0.png";